import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { FormGroup } from '@angular/forms';
import { WorkflowContextService } from 'src/app/services';
import { ReviewActivity } from 'src/app/models/activities/review-activity';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-review-activity-input',
    templateUrl: './review-activity-input.component.html',
    styleUrls: ['./review-activity-input.component.css'],
    standalone: false
})
export class ReviewActivityInputComponent
  implements OnInit, ActivityView {
  activity: ReviewActivity;
  isPreview: boolean;
  isTestApplication: boolean;
  showSave?: EventEmitter<boolean>;
  showCancel?: EventEmitter<boolean>;
  showNext?: EventEmitter<boolean>;
  showPrevious?: EventEmitter<boolean>;
  goNext?: EventEmitter<boolean>;
  value$: EventEmitter<any>;
  initActivity: any;
  nextOnSelect = false;
  form: FormGroup;
  context: WorkflowContextService;
  applicationId?: string;
  templateForPermitForm: boolean = false;         // Added by Vipul on 16/12/2025

  viewTitle(): string {
    return this.activity.model.screenName;
  }

  constructor(    public layoutService: LayoutService, context: WorkflowContextService) {
    // Started by Vipul on 16/12/2025
   layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 16/12/2025
  }

  ngOnInit() {}
  // Started by Vipul on 16/12/2025
  onActivityToggle(activityId: string): void {
    this.toggleActivity(activityId);
  }

  toggleActivity(id: string): void {
    const element = document.getElementById(id);
    if (!element) return;

    element.classList.toggle('show');
  }

  // End by Vipul on 16/12/2025

}
